import Ajax from '../../modules/ajax/ajax';
import Component from '../component/component';

import './video.scss';

export interface IVideoSettings {
    videoHolder?: string;
    videoClass?: string;
    readyClass?: string;
}

export default class Video extends Component {
    static initSelector: string = '.js-video';
    static readyClass: string = 'is-ready';
    static videoClass: string = 'video';
    static loadingClass: string = 'is-loading';

    settings: IVideoSettings;
    // eslint-disable-next-line
    vimeoOptions: any;
    iframe: JQuery;
    // eslint-disable-next-line
    player: any;
    initialized: boolean;
    checkInitialized: boolean;
    videoContainer: JQuery;
    videoId?: string;
    autoplay: boolean;
    private url: string;

    private videoOverlay: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            readyClass: Video.readyClass,
            videoClass: 'video__video',
            videoHolder: 'video__figure',
        };

        this.videoContainer = this.element.find('.' + this.settings.videoHolder);
        this.iframe = this.element.find('iframe');
        this.url = this.videoContainer.data('src');
        this.videoOverlay = this.element.find(`.video__holder`);
        this.autoplay = this.videoContainer.data('autoplay');

        if (this.autoplay) {
            this.initVideos();
        } else {
            this.videoOverlay.on('click', this.initVideos.bind(this));
        }
    }

    removeVideoOverlay(): void {
        this.element.find(`.video__image`).addClass('is-hidden');
        this.videoOverlay.addClass('is-hidden');
    }

    initVideos(event?: JQuery.ClickEvent): void {
        if (event) {
            event.preventDefault();
        }
        this.element.addClass(Video.loadingClass);

        this.videoLoader();

        this.videoOverlay.off('click');
    }

    videoLoader(): void {
        this.removeVideoOverlay();

        if (this.isYoutube(this.url)) {
            this.loadYoutubeVideo(this.url);
        } else {
            this.loadVimeoVideo(this.url);
        }
    }

    isYoutube(url: string): boolean {
        // If is either youtu.be or youtube link
        return url.includes('youtu');
    }

    loadYoutubeVideo(url: string): void {
        const iframe: JQuery = $(`<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${this.getYoutubeLinkId(url)}?controls=${this.autoplay ? 0 : 1}&autoplay=${this.autoplay ? 1 : 0}&mute=${this.autoplay ? 1 : 0}" allow="autoplay"></iframe>`);
        const iFrameContainer: JQuery = this.element.find('.video__video');

        iFrameContainer.append(iframe);

        this.fitVideo();
        $(window).on('resize', this.fitVideo.bind(this));

        this.element.addClass(Video.readyClass);
        this.element.removeClass(Video.loadingClass);
    }

    getYoutubeLinkId(url: string): string {
        if (url.includes('youtu.be/')) {
            const videoIdfromShareLink: string = url.split('.be/')[1];

            return videoIdfromShareLink;
        }

        if (url.includes('youtube.com/embed/')) {
            const videoIdfromEmbed: string = url.split('/embed/')[1];

            return videoIdfromEmbed;
        }

        const videoId: string = url.split('v=')[1];
        const ampersandPosition: number = videoId.indexOf('&');

        if (ampersandPosition !== -1) {
            return videoId.substring(0, ampersandPosition);
        }

        return videoId;
    }

    // eslint-disable-next-line
    loadVimeoVideo(url: string): void {
        $.ajax({
            async: false,
            // eslint-disable-next-line
            success: (response) => {
                if (response.video_id) {
                    const videoUrl: string = this.videoContainer.data('src');

                    this.vimeoOptions = {
                        autoplay: true,
                        background: false,
                        byline: false,
                        controls: this.autoplay ? false : true,
                        dnt: true,
                        loop: true,
                        muted: this.autoplay ? true : false,
                        title: false,
                        url: videoUrl,
                    };
                    const uniqueId: string = Math.random().toString(36).substr(2, 9);

                    this.videoId = 'video_' + uniqueId + response.video_id;
                    this.element.find('.' + this.settings.videoClass).attr('id', this.videoId);
                    this.init();
                }
            },
            url: 'https://vimeo.com/api/oembed.json?url=' + url,
        });
    }

    init(): void {
        this.fitVideo();
        $(window).on('resize', this.fitVideo.bind(this));

        if (!gotoAndPlay.vimeoApiLoaded) {
            this.loadVimeoAPI().done(() => {
                gotoAndPlay.vimeoApiLoaded = true;
                this.checkAutoPlay();
            });
        } else {
            this.checkAutoPlay();
        }
    }

    loadVimeoAPI(): JQueryXHR {
        return Ajax.loadScript('https://player.vimeo.com/api/player.js');
    }

    checkAutoPlay(): void {
        this.checkInitialized = true;

        if (gotoAndPlay.vimeoApiLoaded && this.iframe) {
            try {
                this.player = new Vimeo.Player(this.videoId, this.vimeoOptions);
            } catch (error) {
                this.player = null;
            }

            if (this.player) {
                this.player.on('timeupdate', (data: { seconds: number, percent: number, duration: number }) => {
                    if (data.seconds > 0 && !this.element.hasClass(this.settings.readyClass)) {
                        this.element.addClass(this.settings.readyClass);
                        this.element.removeClass(Video.loadingClass);
                    }
                });
            }
        }
    }

    fitVideo(): void {
        const videoAspectRatio: number = 16 / 9;
        const videoHolderHeight: number = this.videoContainer.parent().height();
        const videoHolderWidth: number = this.videoContainer.parent().width();
        const videoWidth: number = videoHolderHeight * videoAspectRatio;

        if (videoWidth < videoHolderWidth) {
            this.videoContainer.width(videoHolderWidth + 'px');
        } else {
            this.videoContainer.width(videoWidth + 'px');
        }
    }
}
